import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import countriesComponent from './countries.component';

let countriesModule = angular
  .module('countries', [
    uiRouter
  ])
  .component('countries', countriesComponent)
  .name;

export default countriesModule;



// WEBPACK FOOTER //
// ./src/app/components/countries/countries.module.js